import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Restricted } from "@/components/pages";
import { usePermissions } from "./PermissionContext";
import { EPermission } from "./types";

interface RequirePermissionProps {
  permission?: EPermission;
  anyOf?: EPermission[];
  allOf?: EPermission[];
  accessMessage?: string;
  children?: ReactNode;
  fallback?: ReactNode;
}

export const RequirePermission = ({ permission, anyOf, allOf, accessMessage, children, fallback }: RequirePermissionProps) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (anyOf && anyOf.length > 0) {
    hasAccess = hasAnyPermission(anyOf);
  } else if (allOf && allOf.length > 0) {
    hasAccess = hasAllPermissions(allOf);
  }

  if (!hasAccess) {
    if (fallback) {
      return <>{fallback}</>;
    }

    if (children) {
      return null;
    }

    return <Restricted className="-mb-12" accessMessage={accessMessage} />;
  }

  return children ? <>{children}</> : <Outlet />;
};
